import React, { useRef } from 'react'
import { useWebRegisterStatusManager } from '../../../../ng-compat/hooks'
import { EcomApiResponse } from '../../../payments/ecom-refund-modal/helpers/types'
import { EcomRefundModal } from '../../../payments/ecom-refund-modal/EcomRefundModal'
import { EcomRefundOption, SalePayment } from './types'
import { OfflinePayment } from './OfflinePaymentModal'

type Props = {
  paymentOption: EcomRefundOption
  onSuccess: (result: SalePayment) => void
  onClose: () => void
}

export const EcomRefund = ({ paymentOption, onSuccess, onClose }: Props) => {
  const isClosing = useRef<boolean>(false)
  const isOffline = !useWebRegisterStatusManager().isOnline()

  if (isOffline) {
    return (
      <OfflinePayment
        paymentName={paymentOption.paymentType.name}
        onClose={onClose}
      />
    )
  }

  const handleModalClose = async (
    responsePromise?: Promise<EcomApiResponse>
  ): Promise<void> => {
    if (isClosing.current) {
      return
    }

    isClosing.current = true

    if (!responsePromise) {
      onClose()

      return
    }

    const response = await responsePromise

    if (response.success) {
      onSuccess({
        paymentType: paymentOption.paymentType,
        paymentAmount: paymentOption.amount,
        transactionData: {
          payment_id: paymentOption.registerSalePaymentId,
        },
      })
    }
  }

  return (
    <EcomRefundModal
      amount={paymentOption.amount}
      originalSaleId={paymentOption.originalSaleId}
      registerId={paymentOption.registerId}
      registerSalePaymentId={paymentOption.registerSalePaymentId}
      close={handleModalClose}
    />
  )
}
